import { normalizeString } from '@uikit/utils/normalizeString';

type Option = { label: string; value: string; synonyms?: string[] | null };
type DataItem = {
  id: string;
  name: string;
  synonyms: string[] | null;
};

function normalizeSearchValue(value: string) {
  return normalizeString(value).toLowerCase();
}

export function filterOptions(
  value: string,
  options: Option[],
  isEnabled: boolean = true
) {
  if (!isEnabled) {
    return [];
  }

  if (!value) {
    return options;
  }

  return options.filter(
    (option) =>
      normalizeSearchValue(option.label).includes(
        normalizeSearchValue(value)
      ) ||
      (option.synonyms &&
        option.synonyms.some((suggestion) =>
          normalizeSearchValue(suggestion).includes(normalizeSearchValue(value))
        ))
  );
}

export function findSelectedOptionValue(label: string, options: Option[]) {
  const selectedOption = options.find((option) => option.label === label);

  if (!selectedOption) {
    return null;
  }

  return selectedOption.value;
}

export function dataToOptions(data: DataItem[] | null | undefined): Option[] {
  if (!data) {
    return [];
  }

  return data.map(({ id, name, synonyms }) => ({
    value: id,
    label: name,
    synonyms,
  }));
}
